//TEST: https://d2fnuxq3o4laa0.cloudfront.net
//COL: https://dn15q4hlc2a6q.cloudfront.net
//PROD: https://d11tnzykyj38rc.cloudfront.net

//https://csrcol.auth.eu-west-1.amazoncognito.com/oauth2/authorize?identity_provider=SKYADCol&redirect_uri=https://scheme-col.sky.it&response_type=TOKEN&client_id=6ccntq1o8dv487bp3l105ucpgk&scope=openid

const envData =
  process.env.REACT_APP_TARGET_ENV == "dev"
    ? {
        APP_BASE_NAME: "/",
        APP_API_TOKEN: "w0aj2h4tqgy6ezb9d51nluio",
        APP_PROPERTY_TITLE: "SeacPortal",
        APP_API_GATEWAY: "https://pxl-test.sky.com/test",
        APP_LOGIN:
          "https://skyukcontent.auth.eu-west-1.amazoncognito.com/login?client_id=4st10t647n9thaqmqk37ar52i2&response_type=code&scope=openid+profile&redirect_uri=https%3A%2F%2Fpxl-test.sky.com%2Ftest%2Foauth2-callback",
        APP_CLOUDFRONT_URLIMG: "https://dnbqthcxeo0st.cloudfront.net/media",
        MOVIE: 3661,
        PROGRAMMES: 3662,
        SEASON: 3667,
        PLACEHOLDER_IMG_URL:
          "https://d1jwml2ax5h472.cloudfront.net/static-images/placeholder.jpg",
        APP_DOWNLOAD_BASE_URL: "https://d31h4s4mt2n9xt.cloudfront.net/",
        IMAGES_BUCKET: "enterprisedam-test-s3",
        USE_FAKE_MODEL: true,
        CLOUDFRONT_CHANNELS_LOGOS_URL:
          "https://d1jwml2ax5h472.cloudfront.net/portal-external-resources/channelLogos/",
      }
    : process.env.REACT_APP_TARGET_ENV == "test"
    ? {
        APP_BASE_NAME: "/",
        APP_API_TOKEN: "w0aj2h4tqgy6ezb9d51nluio",
        APP_PROPERTY_TITLE: "SeacPortal",
        APP_API_GATEWAY: "https://pxl-test.sky.com/test",
        APP_LOGIN:
          "https://skyukcontent.auth.eu-west-1.amazoncognito.com/login?client_id=4st10t647n9thaqmqk37ar52i2&response_type=code&scope=openid+profile&redirect_uri=https%3A%2F%2Fpxl-test.sky.com%2Ftest%2Foauth2-callback",
        APP_CLOUDFRONT_URLIMG: "https://dnbqthcxeo0st.cloudfront.net/media",
        MOVIE: 3661,
        PROGRAMMES: 3662,
        SEASON: 3667,
        PLACEHOLDER_IMG_URL:
          "https://d1jwml2ax5h472.cloudfront.net/static-images/placeholder.jpg",
        APP_DOWNLOAD_BASE_URL: "https://d31h4s4mt2n9xt.cloudfront.net/",
        IMAGES_BUCKET: "enterprisedam-test-s3",
        USE_FAKE_MODEL: false,
        CLOUDFRONT_CHANNELS_LOGOS_URL:
          "https://d1jwml2ax5h472.cloudfront.net/portal-external-resources/channelLogos/",
      }
    : process.env.REACT_APP_TARGET_ENV == "stage"
    ? {
        APP_BASE_NAME: "/",
        APP_API_TOKEN: "wokl7p9m51xa623zy8jhuvgd",
        APP_PROPERTY_TITLE: "pxlPortal",
        APP_API_GATEWAY: "https://pxl-stage.sky.com/stage",
        APP_LOGIN:
          "https://skyukcontentstage.auth.eu-west-1.amazoncognito.com/login?client_id=rsb3j3shtp0ovpbnmt6nksild&response_type=code&scope=openid+profile&redirect_uri=https%3A%2F%2Fpxl-stage.sky.com%2Fstage%2Foauth2-callback",
        APP_CLOUDFRONT_URLIMG: "https://d3p5e0vluzgypt.cloudfront.net/media",
        MOVIE: 3533,
        PROGRAMMES: 3534,
        SEASON: 3536,
        PLACEHOLDER_IMG_URL:
          "https://d21cc3i8uxg2g9.cloudfront.net/static-images/placeholder.jpg",
        APP_DOWNLOAD_BASE_URL: "https://d2n840l7bv7jqr.cloudfront.net/",
        IMAGES_BUCKET: "enterprisedam-stage-s3",
        USE_FAKE_MODEL: false,
        CLOUDFRONT_CHANNELS_LOGOS_URL:
          "https://d21cc3i8uxg2g9.cloudfront.net/portal-external-resources/channelLogos/",
      }
    : process.env.REACT_APP_TARGET_ENV == "prod"
    ? {
        APP_BASE_NAME: "/",
        APP_API_TOKEN: "p4jf16o3vcwtz8xnsqm7eyb2",
        APP_PROPERTY_TITLE: "PxlPortal",
        APP_API_GATEWAY: "https://pxl.sky.com/prod",
        APP_LOGIN:
          "https://skyukcontentprod.auth.eu-west-1.amazoncognito.com/login?client_id=23er30qi6o3ncoelvft4uioj78&response_type=code&scope=openid+profile&redirect_uri=https%3A%2F%2Fpxl.sky.com%2Fprod%2Foauth2-callback",
        APP_CLOUDFRONT_URLIMG: "https://d3qp0rh9g8u1hc.cloudfront.net/media",
        MOVIE: 4208,
        PROGRAMMES: 4209,
        SEASON: 4211,
        PLACEHOLDER_IMG_URL:
          "https://d15ustv9ukovwh.cloudfront.net/static-images/placeholder.jpg",
        APP_DOWNLOAD_BASE_URL: "https://d1cac6kyodkqq2.cloudfront.net/",
        IMAGES_BUCKET: "enterprisedam-s3",
        USE_FAKE_MODEL: false,
        CLOUDFRONT_CHANNELS_LOGOS_URL:
          "https://d15ustv9ukovwh.cloudfront.net/portal-external-resources/channelLogos/",
      }
    : {
        APP_BASE_NAME: "/",
        APP_API_TOKEN: "w0aj2h4tqgy6ezb9d51nluio",
        APP_PROPERTY_TITLE: "SeacPortal",
        APP_API_GATEWAY: "https://pxl-test.sky.com/test",
        APP_LOGIN:
          "https://skyukcontent.auth.eu-west-1.amazoncognito.com/login?client_id=4st10t647n9thaqmqk37ar52i2&response_type=code&scope=openid+profile&redirect_uri=https%3A%2F%2Fpxl-test.sky.com%2Ftest%2Foauth2-callback",
        APP_CLOUDFRONT_URLIMG: "https://dnbqthcxeo0st.cloudfront.net/media",
        MOVIE: 3661,
        PROGRAMMES: 3662,
        SEASON: 3667,
        PLACEHOLDER_IMG_URL:
          "https://d1jwml2ax5h472.cloudfront.net/static-images/placeholder.jpg",
        APP_DOWNLOAD_BASE_URL: "https://d31h4s4mt2n9xt.cloudfront.net/",
        IMAGES_BUCKET: "enterprisedam-test-s3",
        USE_FAKE_MODEL: true,
        CLOUDFRONT_CHANNELS_LOGOS_URL:
          "https://d1jwml2ax5h472.cloudfront.net/portal-external-resources/channelLogos/",
      };

export default envData;
